import axios from "@/api/axios";

const postAppeal = (item) => {
  return axios.post(`/petition/save`, item);
};

export default {
  postAppeal,
};
